import flatpickr from 'flatpickr'

const call = (datePickElement, currentDate, browseLink) => {
    return {
        async start() {
            flatpickr(datePickElement, {
                //inline: true,
                altInput: true,
                altFormat: 'F j, Y',
                dateFormat: 'm-d-Y',
                defaultDate: currentDate,
                onChange: function (selectedDates, dateStr) {
                    window.location.href = `${browseLink}${dateStr}/`
                },
            });
        }
    };
};

export default call;